<template>
  <div class="row">
    <div class="col">
      <b-card class="shadow border overflow-hidden">
        <b-card-header :header-class="'text-center text-md-left rounded-top'">
          {{ $t('Links to listings') }}
        </b-card-header>
        <b-card-body v-if="!busy" class="p-3">
          <b-alert v-if="!listingMasterSwitch" :show="true" variant="warning">
            <div>
              <i18n path="inactiveListing">
                <template #contact>
                  <router-link class="text-link text-link-reset" :to="{path:'/help/contact'}">
                    {{ $t('contact') }}
                  </router-link>
                </template>
              </i18n>
            </div>
          </b-alert>
          <div v-else-if="(bgListing === undefined && sgListing === undefined)">
            {{ $t('You do not have any live listings, or your company and work types have not been approved yet.') }}'
          </div>
          <div v-else class="row text-center flex-column justify-content-center flex-md-row my-5 pt-5 pb-5">
            <div class="col-12 mb-3">
              <h2 class="text-center h3">
                {{ $t('View Listings live on:') }}
              </h2>
            </div>
            <div class="col d-flex align-items-center justify-content-center flex-column flex-md-row">
              <template v-if="bgListing">
                <a
                  id="bgLink"
                  :class="['site-link', 'btn-sm', 'btn', 'btn-outline-secondary', {'site-link--disabled' : !listingMasterSwitch || !bgListing.listing.online}]"
                  :href="(bgListing.listing.online) ? bgListing.url : null"
                  target="_blank"
                >
                  <img src="https://www.boilerguide.co.uk/images/logo.png" alt="logo" class="img-fluid mr-2">
                  <font-awesome-icon icon="external-link-alt" />
                </a>
                <b-tooltip v-if="!listingMasterSwitch || !bgListing.listing.online" target="bgLink" placement="top">
                  <i18n path="siteInactiveTooltip">
                    <template #siteName>
                      {{ $t('boilerguide.co.uk') }}
                    </template>
                    <template #contact>
                      <router-link class="text-link text-link-reset" :to="{path:'/help/contact'}">
                        {{ $t('contact') }}
                      </router-link>
                    </template>
                  </i18n>
                </b-tooltip>
              </template>
              <template v-if="sgListing">
                <a
                  v-if="sgListing"
                  id="sgLink"
                  :class="['site-link', 'btn-sm', 'btn', 'btn-outline-secondary', {'site-link--disabled' : !listingMasterSwitch || !sgListing.listing.online}]"
                  :href="(sgListing.listing.online) ? sgListing.url: null"
                  target="_blank"
                >
                  <img src="https://www.solarguide.co.uk/images/logo.png" alt="logo" class="img-fluid mr-2">
                  <font-awesome-icon icon="external-link-alt" />
                </a>
                <b-tooltip v-if="!listingMasterSwitch || !sgListing.listing.online" target="sgLink" placement="top">
                  <i18n path="siteInactiveTooltip">
                    <template #siteName>
                      {{ $t('solarguide.co.uk') }}
                    </template>
                    <template #contact>
                      <router-link class="text-link text-link-reset" :to="{path:'/help/contact'}">
                        {{ $t('contact') }}
                      </router-link>
                    </template>
                  </i18n>
                </b-tooltip>
              </template>
            </div>
          </div>
        </b-card-body>
        <spinner v-else />
      </b-card>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/animation/Spinner";

export default {
  name: "ListingLinks",
  components: {Spinner},
  data: function() {
    return {
      bgListing: null,
      sgListing: null,
      busy:true,
    }
  },
  computed: {
    listingMasterSwitch: function() {
      return (this.$store.state.company.COMPANY) ? this.$store.state.company.COMPANY.show_listing : true;
    },
  },
  methods: {
    getLiveListings: async function() {
      this.busy = true;
      this.$api.company.getLiveListings().then((response) => {
        this.bgListing = response.data.data.listings['boilerguide.co.uk'];
        this.sgListing = response.data.data.listings['solarguide.co.uk'];
      })
        .finally(() => this.busy = false);
    },
  },
  created: function() {
    this.getLiveListings();
  }
}
</script>

<style scoped lang="scss">
.site-link {
  max-width: 150px;
  min-height: 38px;
  display: flex;
  margin-left: .5rem !important;
  margin-right: .5rem !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  &--disabled {
    cursor: not-allowed !important;
    opacity: 0.2;
  }
  img {
    max-width: 95px;
  }
}
</style>
